export default __webpack_public_path__ + "static/media/Techshop3.b339ed28.png";